export default __webpack_public_path__ + "static/media/Toparrow.b92c4d7a.svg";